/* Use the original form so quantity, variant selection, and validation stay in sync. */
if (!customElements.get('sticky-purchase')) {
  customElements.define('sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.page = document.getElementById(`ProductPage-${this.dataset.sectionId}`);
      this.button = this.querySelector('[data-sticky-submit]');
      if (!this.page || !this.button) return;
      this.update = () => {
        const mainButton = this.page.querySelector('.product-form .button-add-to-cart');
        if (!mainButton) { this.hidden = true; document.body.classList.remove('has-sticky-purchase'); return; }
        const price = this.page.querySelector(`[id="price-${this.dataset.sectionId}"]`);
        const stock = this.page.querySelector(`[id="ProductAvailability-${this.dataset.sectionId}"]`);
        const priceText = price?.innerText.trim() || '';
        const stockText = stock?.innerText.trim() || '';
        this.setText('[data-sticky-price]', priceText);
        this.setText('[data-sticky-stock]', stockText);
        const error = this.page.querySelector('.product-form-error-message-wrapper:not([hidden])');
        const errorText = error?.innerText.trim() || '';
        this.setText('[data-sticky-error]', errorText);
        const errorNode = this.querySelector('[data-sticky-error]');
        if (errorNode.hidden !== !errorText) errorNode.hidden = !errorText;
        this.button.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
        this.setText('[data-sticky-submit]', mainButton.innerText.trim());
        this.hidden = mainButton.getBoundingClientRect().bottom >= 0;
        document.body.classList.toggle('has-sticky-purchase', !this.hidden);
        if (!this.hidden) document.body.style.setProperty('--sticky-purchase-height', `${this.offsetHeight}px`);
      };
      this.submit = () => {
        const mainButton = this.page.querySelector('.product-form .button-add-to-cart');
        if (mainButton && !mainButton.disabled && mainButton.getAttribute('aria-disabled') !== 'true') {
          mainButton.click();
          const error = this.page.querySelector('.product-form-error-message-wrapper:not([hidden])');
          if (error?.innerText.trim()) error.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      };
      this.button.addEventListener('click', this.submit);
      window.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.update();
      });
      // Exclude the sticky control to avoid observing our own updates.
      [...this.page.querySelectorAll('.product-info-wrap-content, .product-info-sidebar')].forEach(node => {
        this.observer.observe(node, { subtree: true, childList: true, attributes: true, characterData: true });
      });
      this.update();
    }
    setText(selector, value) {
      const node = this.querySelector(selector);
      if (node.textContent !== value) node.textContent = value;
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.update);
      window.removeEventListener('resize', this.update);
      this.button?.removeEventListener('click', this.submit);
      this.observer?.disconnect();
      document.body.classList.remove('has-sticky-purchase');
    }
  });
}
